import React from 'react';
import AuthService from './authService';
import TpClientInvoiceLineItem from '../Domain/TpClientInvoiceLineItem';
import SearchParams from '../Elements/SearchParams';
import TpClientInvoiceLineItemAndJobLineSearchParams from '../Contents/Operations/TpClientInvoice/Details/TpClientInvoiceLineItemAndJobLineSearchParams';
import TpClientInvoiceLineItemSearchParams from '../Contents/Operations/TpClientInvoice/Details/TpClientInvoiceLineItemSearchParams';

export default class TpClientInvoiceLineItemService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpClientInvoiceLineItemSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpClientInvoiceLineItem/GetListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=true`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpClientInvoiceLineItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetListBySearchingWithJobLine(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TpClientInvoiceLineItemAndJobLineSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpClientInvoiceLineItem/GetListBySearchingWithJobLineAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=true`
    );
  }

  static ExportToExcel(searchItem) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpClientInvoiceLineItem/LineItemExcelExportAsync/?searchParams=${JSON.stringify(
        searchItem
      )}&clearCache=true`
    );
  }

  static ExportToExcelWithJobLine(searchItem) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpClientInvoiceLineItem/LineItemWithJobLineExcelExportAsync/?searchParams=${JSON.stringify(
        searchItem
      )}&clearCache=true`
    );
  }

  static Upsert(upsertItem) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpClientInvoiceLineItem/UpsertAsync/',
      JSON.stringify(upsertItem)
    );
  }

  static GetById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/TpClientInvoiceLineItem/GetByIdAsync/${id ? id : 0}`);
  }

  static ChangeProjectOfPrepayment(item) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpClientInvoiceLineItem/ChangeProjectOfPrepaymentAsync/',
      JSON.stringify(item)
    );
  }
}
